// 自動生成 — 編集しないでください。
// 生成元: scripts/seo/generate-learn-pages.mjs（公開ページを作るのと同じデータを数えています）
// 数え方: scripts/seo/topics/*.json の topics 件数。track が '2次' のものを2次、それ以外を1次として集計。
// pages は実際に書き出した index.html の本数（論点ページ＋科目ハブ＋年度別傾向＋総合ハブ）。
export const LEARN_STATS = {
    primarySubjects: 7,
    primaryTopics: 154,
    secondaryCases: 4,
    secondaryTopics: 48,
    totalTopics: 202,
    pages: 217,
} as const;
